module.exports = __webpack_public_path__ + "static/img/3-6.10.5.19331ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/5/3-6.10.5.png
// module id = aTT1
// module chunks = 0